import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVersions } from './api-version';
import { BaseService } from './base.service';
import { CustomDocumentUploadFile } from '../../../shared-app-portal/components/custom-document-uploader/custom-document-upload-file';
import { map } from 'rxjs/operators';
import { buildFileUploadData } from '../../../shared-app-portal/components/document-upload/document-upload.helper';

@Injectable({
  providedIn: 'root'
})
export class CustomDocumentService extends BaseService {
  public getProfileDocumentUploadPath(entityId: string, attributeDefinitionId: string) {
    return {
      path: `user/${entityId}/custom-fields/${attributeDefinitionId}/custom-document`,
      apiVersion: ApiVersions.v1_0
    };
  }

  public getProfileDocumentDeletePath(
    path: string,
    fileName: string,
    tenantId: string,
    entityId: string
  ) {
    return path
      .replace('user', `${tenantId}/person-documents`)
      .replace('custom-fields/', '')
      .replace('custom-document', fileName);
  }

  uploadDocument(
    file: CustomDocumentUploadFile,
    path: string,
    apiVersion: ApiVersions = ApiVersions.v0_1
  ): Observable<CustomDocumentUploadFile> {
    return this.doUpload(path, file, apiVersion).pipe(
      map((response: any) => {
        if (response) {
          file.isUploading = false;
          return file;
        }
        return null;
      })
    );
  }

  private doUpload(
    endpoint: string,
    file: CustomDocumentUploadFile,
    apiVersion: ApiVersions
  ): Observable<any> {
    const formData = buildFileUploadData(file.rawFile);
    return this.post(endpoint, formData, {}, apiVersion, true);
  }
}
